import "leaflet/dist/leaflet.css"
import Map from "./map";
import Dashboard from "./dashboard";
 
export default function Main({flight,lastupdate,backcolor,search}) {
  return (
    <div
      style={{
        height: "70%",
        display: "flex",
        padding: "0",
        margin: "0",
        width: "100%",
        position:"relative"
     
     
      }}
    >
      <Map  flight={flight} search={search}></Map>
      <Dashboard flight={flight} lastupdate={lastupdate} backcolor={backcolor} ></Dashboard>
    </div>
  );
}
